import(/* webpackMode: "eager" */ "/vercel/path0/casey-scholar-app/node_modules/next/dist/client/link.js");
